import { render, staticRenderFns } from "./BooksIcon.vue?vue&type=template&id=0f4205d4&"
import script from "./BooksIcon.vue?vue&type=script&lang=ts&"
export * from "./BooksIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports